export default __webpack_public_path__ + "static/media/pjHarvey.c9b89c7a.jpg";